import { render, staticRenderFns } from "./VSoftwareFooterInfo.vue?vue&type=template&id=b3fa6f7a"
import script from "./VSoftwareFooterInfo.vue?vue&type=script&lang=js"
export * from "./VSoftwareFooterInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports